<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M5.67,782.5c-2.67,0-4.83,2.16-4.83,4.83l0,0c0,2.67,2.16,4.83,4.83,4.83l0,0c2.67,0,4.83-2.16,4.83-4.83l0,0
	C10.5,784.66,8.34,782.5,5.67,782.5L5.67,782.5z M-7.8,802.5l2.83-2.83l-1.7-1.7l-2.83,2.83L-7.8,802.5z M-4.2,798.89l2.83-2.83
	l-1.7-1.7l-2.83,2.83L-4.2,798.89z M-0.65,795.35l2.83-2.83l-1.7-1.7l-2.83,2.83L-0.65,795.35L-0.65,795.35z"/>
</svg>

</template>